import React, {Component} from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  oldPwd: '',
  newPwd: '',
  reNewPwd: '',
  complete: false,
  errorMap: null,
  loading: false,
  showPwd: false
}

class PwdChange extends Component {
  state = initialState;

  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_pwd_change');

  }

  // パスワード変更画面[変更]ボタン押下時処理
  pwdChange = async ()  => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');

    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("password_reset_change", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
       // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    const { oldPwd, newPwd, reNewPwd } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // 画面入力項目のバリデーションチェックを行う
    if (oldPwd === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdChange.M016_errorMessage001, errorId: ['oldPwd'] }, });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (newPwd === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdChange.M017_errorMessage002, errorId: ['newPwd'] }, });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (newPwd !== reNewPwd) {
      this.setState({ errorMap: { ERROR: messageList.pwdChange.M018_errorMessage003, errorId: ['newPwd', 'reNewPwd'] }, newPwd: '', reNewPwd: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    // パスワード変更要求を行う
    try {
      // ローディング開始
      this.setState({ loading: true });

      // 3Keyパスワード変更API
      axios
        .put( process.env.REACT_APP_URL_CO_SC_API_PASSWORD_CHANGE,
          {
            newPassword: newPwd,
            oldPassword: oldPwd
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
        .then( response => {
          this.setState({ errorMap: null, complete: true, loading: false });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_pwd_change_completion');
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdChange.M019_errorMessage004 },
                loading: false, oldPwd: '', newPwd: '', reNewPwd: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdChange.M019_errorMessage004 },
                loading: false, oldPwd: '', newPwd: '', reNewPwd: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 500 ) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdChange.M019_errorMessage004 },
                loading: false, oldPwd: '', newPwd: '', reNewPwd: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.pwdChange.M019_errorMessage004 },
              loading: false, oldPwd: '', newPwd: '', reNewPwd: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pwdChange.M019_errorMessage004 },
        loading: false, oldPwd: '', newPwd: '', reNewPwd: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワード表示切り替え処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank','_self').close();
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));
    // デザイン定義ファイルを読み込み
    let designJson = require('../jsonFile/design.json');
    // デザイン値をセッションから読み込み
    let design = sessionStorage.getItem('design');

    // JOHNデザインの場合、デザイン値に応じたファイルを設定
    let cahgeDesign;
    let completeDesign;

    // パスワード変更画面用のデザインファイル設定
    Object.keys(designJson.pwdChange.I01).forEach(function(data) {
      if (data === design) {
        cahgeDesign = require('./design/' + designJson.pwdChange.I01[data]);
      }
    });
    if(!cahgeDesign){
      cahgeDesign = require('./design/' + designJson.pwdChange.I02['default']);
    }

    // パスワード変更完了画面用のデザインファイル設定(JOHNデザインのみ設定)
    Object.keys(designJson.pwdChange.I03).forEach(function(data) {
      if (data === design) {
        completeDesign = require('./design/' + designJson.pwdChange.I03[data]);
      }
    });

    // パスワード変更完了画面表示
    if (this.state.complete){
      return (
        <section className="content">
          <Helmet
            title={messageList.pwdChangeCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pwdChangeCompletion.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            <div id="JS_error">
            { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pwdChange.M003_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pwdChange.M004_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>
            }
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.close}>
                    <span className="ds-button__label">{messageList.pwdChangeCompletion.M003_close}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          {(completeDesign) && completeDesign.getDesign(messageList.pwdChangeCompletion)}

        </section>
      );
    }

    // パスワード変更画面表示
    else {
      return (
        <section className="content">
          <Helmet
            title={messageList.pwdChange.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pwdChange.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            <div id="JS_error">
            { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pwdChange.M003_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pwdChange.M004_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>
            }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">
                  <div className="formList">

                    {/* 現在のパスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-1">
                          <span className="formLabel__text">{messageList.pwdChange.M005_oldPassword}</span>
                        </label>
                        <input
                          type={ this.state.showPwd ? "text" : "password"}
                          id="LB_input-password-1"
                          name="oldPwd"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('oldPwd') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256"
                          autoComplete="current-password"
                          required
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('oldPwd') ? "true" : "false"}
                          value={this.state.oldPwd} onChange={this.handleChange}/>
                      </div>
                    </div>

                    {/* 変更後のパスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-2">
                          <span className="formLabel__text">{messageList.pwdChange.M006_newPassword}</span>
                        </label>
                        <p id="WA_input-password-text" className="formLabelSub">{messageList.pwdChange.M007_newPasswordType}</p>
                        <a href={messageList.pwdChange.M022_noticeUrl001} className="ds-textLink ds-textLink--linkBlank u-fz-12" target="_blank" rel="noopener noreferrer">
                          {messageList.pwdChange.M009_aboutPassword}&nbsp;
                          <span className="ds-textLink__icon">
                            <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.pwdChange.M008_aboutPasswordIcon}>
                              <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                            </svg>
                          </span>
                        </a>
                        <input
                          type={ this.state.showPwd ? "text" : "password"}
                          id="LB_input-password-2"
                          name="newPwd"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('newPwd') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256"
                          autoComplete="new-password"
                          required
                          aria-describedby="WA_input-password-text"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('newPwd') ? "true" : "false"}
                          value={this.state.newPwd} onChange={this.handleChange}/>
                      </div>
                    </div>

                    {/* 変更後のパスワード再入力 */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-3">
                          <span className="formLabel__text">{messageList.pwdChange.M010_reNewPassword}</span>
                        </label>
                        <input
                          type={ this.state.showPwd ? "text" : "password"}
                          id="LB_input-password-3"
                          name="reNewPwd"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('reNewPwd') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256"
                          autoComplete="new-password"
                          required
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('reNewPwd') ? "true" : "false"}
                          value={this.state.reNewPwd} onChange={this.handleChange} />

                        {/* パスワードを表示する */}
                        <label className="ds-checkbox">
                          <input
                            className="ds-checkbox__input"
                            type="checkbox"
                            name="checkPassword"
                            aria-controls="LB_input-password-1 LB_input-password-2 LB_input-password-3"
                            onChange={this.swhichPwdShow} />
                          <span className="ds-checkbox__partsWrap">
                            <span className="ds-checkbox__parts" role="presentation"></span>
                            <span className="ds-checkbox__text">{messageList.pwdChange.M011_showPassword}</span>
                          </span>
                        </label>
                      </div>
                    </div>

                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.pwdChange}>
                          <span className="ds-button__label">{messageList.pwdChange.M012_update}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          {(cahgeDesign) && cahgeDesign.getDesign(messageList.pwdChange)}

        </section>
      );
    }
  }
}

export default PwdChange
